export class CustomerCorrespondenceModel {
    public organizationName: string;
    public firstName: string;
    public lastName: string;
    public address1Line1: string;
    public address1Line2: string;
    public address1City: string;
    public address1State: string;
    public address1Zip: string;
}
